var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "16px",
    viewBox: "0 0 11 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333333 0C2.39322933 0 0 2.3932293 0 5.3333333c0 4.704427 4.876302 10.3151044 5.08333333 10.5520834.063802.0729166.153646.1145833.25.1145833.10286467-.0065103.186198-.0416667.25-.1145833.20703134-.2408854 5.08333337-5.9479167 5.08333337-10.5520834C10.6666667 2.3932293 8.2734377 0 5.33333333 0zm0 3.6666667c1.10416667 0 2 .8958333 2 2 0 1.1041666-.89583333 2-2 2-1.10416666 0-2-.8958334-2-2 0-1.1041667.89583334-2 2-2z",
    fill: "#C1CEDE",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.4176050db42cd28ffbd92b12d9ae078e.svg";
export { ForwardRef as ReactComponent };